import { render, staticRenderFns } from "./ColorSelectionLayout.vue?vue&type=template&id=1d70f65d&scoped=true&"
import script from "./ColorSelectionLayout.vue?vue&type=script&lang=js&"
export * from "./ColorSelectionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d70f65d",
  null
  
)

export default component.exports